import { render, staticRenderFns } from "./DataBoard.vue?vue&type=template&id=6d2cb98a&scoped=true&"
import script from "./DataBoard.vue?vue&type=script&lang=js&"
export * from "./DataBoard.vue?vue&type=script&lang=js&"
import style0 from "./DataBoard.vue?vue&type=style&index=0&id=6d2cb98a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2cb98a",
  null
  
)

export default component.exports